import { useEffect } from "react";
import type { ReactNode } from "react";
import ReactTooltip from "react-tooltip";

const TOOLTIP_ID = "hermes-limit";

/**
 * Wraps an action that may be disabled because it is over its limit, so the reason shows on hover.
 * A disabled button receives no mouse events of its own, which is why the tip sits on this wrapper.
 */
export default function LimitTip({ tip, children }: { tip?: string; children: ReactNode }) {
  useEffect(() => {
    ReactTooltip.rebuild();
  }, [tip]);
  return (
    <span data-tip={tip} data-for={TOOLTIP_ID} className="tw-inline-flex">
      {children}
    </span>
  );
}

/** The tooltip LimitTip's wrappers show. Render exactly one (ChatShell does): a second instance with the same id shows a second, overlapping tooltip. */
export function LimitTooltip() {
  return <ReactTooltip id={TOOLTIP_ID} place="top" effect="solid" className="trademo-tooltip" backgroundColor="#374151" textColor="#FFFFFF" />;
}
